import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type PrinterSession = {
  id: string;
  printerName: string;
  department: string;
};

@Injectable({ providedIn: 'root' })
export class PrinterSessionService {
  private readonly KEY = 'printerSession';

  private _sessionSubject = new BehaviorSubject<PrinterSession | null>(
    this.load()
  );

  session$ = this._sessionSubject.asObservable();

  get snapshot(): PrinterSession {
    return this._sessionSubject.value;
  }

  set(printerName: string, department: string): void {
    const id = `${department}-${printerName}`;
    // const current = this._sessionSubject.value;
    // if (current && current.id !== id) {
    //   throw new Error('A printer is already active. Stop it first.');
    // }

    const session: PrinterSession = {
      id,
      printerName,
      department,
    };
    sessionStorage.setItem(this.KEY, JSON.stringify(session));
    this._sessionSubject.next(session);
  }

  clear(): void {
    sessionStorage.removeItem(this.KEY);
    this._sessionSubject.next(null);
  }

  private load(): PrinterSession | null {
    const raw = sessionStorage.getItem(this.KEY);
    return raw ? JSON.parse(raw) : null;
  }
}
